import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { GlobalConfig } from '@shared/configs';
import { PathAPP } from '@shared/constants';
import { AuthService } from '../store';

/**
 * The guard React intended but never ran: `PrivateRoute` returned the
 * component on the first line of its render callback, leaving the logic below
 * unreachable, so every route was public.
 *
 * Gated by `environment.enableAuthGuard` so UI work can proceed before the
 * login endpoint is reachable.
 */
export const authGuard: CanActivateFn = () => {
  if (!GlobalConfig.enableAuthGuard) {
    return true;
  }

  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isLoggedIn() ? true : router.createUrlTree([PathAPP.auth.login]);
};
